import { storefront_query } from './base';

const lineItem = `
  edges {
    node {
      id
      quantity
      title
      variant {
        id
        title
        image {
          transformedSrc(maxWidth:150)
          altText
          id
        }
        price {
          amount
          currencyCode
        }
        product {
          handle
          title
        }
      }
    }
  }
`;

const checkout = `
  id
  lineItems(first:250) {
    ${lineItem}
  }
  subtotalPrice {
    amount
    currencyCode
  }
  webUrl
  completedAt
  createdAt
  ready
  customAttributes {
    key,
    value
  }
`;

/**
 * Create a new Checkout object
 */
export const createCheckout = custom_attributes => {
    return storefront_query(
        `
    mutation cartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
          cost {
            subtotalAmount {
              amount
              currencyCode
            }
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 10) {
            edges {
              node {
                id
                quantity
                attributes {
                  key
                  value
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                     price {
                    amount
                    currencyCode
                  }
                    image {
                      url
                      altText
                    }
                     product {
                    handle
                    title
                  }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
    `,
        {
            input: {
                attributes: custom_attributes || [], // Add custom cart-level attributes if provided
            },
        }
    );
};

export const getCart = cartId => {
    return storefront_query(`
    query getCart($cartId: ID!) {
      cart(id: $cartId) {
        id
        createdAt
        updatedAt
        cost {
          subtotalAmount {
            amount
            currencyCode
          }
          totalAmount {
            amount
            currencyCode
          }
        }
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              attributes {
                key
                value
              }
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  price {
                    amount
                    currencyCode
                  }
                  image {
                    url
                    altText
                  }
                  product {
                    handle
                    title
                  }
                }
              }
            }
          }
        }
        attributes {
          key
          value
        }
      }
    }
  `, { cartId });
};

export const updateCartAttributes = (cartId, attributes) => {
    return storefront_query(
        `
    mutation cartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!) {
      cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
        cart {
          id
          createdAt
          updatedAt
          attributes {
            key
            value
          }
          cost {
            subtotalAmount {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `,
        {
            cartId: cartId,
            attributes: attributes
        }
    );
};

export const cartLinesAdd = (lines, cartId) => {
    return storefront_query(
        `
    mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart {
          id
          checkoutUrl
          cost {
            subtotalAmount {
              amount
              currencyCode
            }
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 250) {
            edges {
              node {
                id
                quantity
                attributes {
                  key
                  value
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                     price {
                    amount
                    currencyCode
                  }
                    image {
                      url
                      altText
                    }
                   product {
                    handle
                    title
                  }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `,
        { cartId, lines }
    );
};

export const replaceLineItems = (lines, cartId) => {
    return storefront_query(
        `
    mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          id
          checkoutUrl
          cost {
            subtotalAmount {
              amount
              currencyCode
            }
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 250) {
            edges {
              node {
                id
                quantity
                attributes {
                  key
                  value
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                     price {
                    amount
                    currencyCode
                  }
                    image {
                      url
                      altText
                    }
                    product {
                    handle
                    title
                  }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `,
        { cartId, lines }
    );
};
